<template>
   	<div class="bg">
   		<div class="rankTitle" id="rankTitle">
   			<i @click="back"><img src="../assets/images/goback_1.png"/></i>
   			<h2>{{singerList[rankPageIndex].name}}</h2>
   		</div>
   		<div class="rankHead" :style="{'background-image':'url('+singerImg+')'}">
   			<div class="plistText">{{shortSingerInfo}}</div>
   		</div>
   		<v-songlist></v-songlist>
   	</div>
</template>

<script>
import songList from '../components/songList.vue'
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
      	singerImg:'',
      	singerInfo:'',
      	songList:'',
      	singerName:'',
      }
    },
    computed: {
    	...mapGetters(['singerList','rankPageIndex']),
    	shortSingerInfo:function(){
    		var temp=this.singerInfo.split('。');
    		if(temp[0].length>101){
    			return temp[0].substr(0,101)+'...'
    		}else{
    			return temp[0];
    		}
    	}
    },
    mounted: function(){
    	this.startView();
    	//this.$store.commit('navShow', false);
    	$(window).scrollTop=0;
    	$(window).scroll(function(){
    		var wh=$(window).scrollTop();
	    	var th=$('.rankTitle').scrollTop();
	    	if(wh>140){
	    		$('#rankTitle').addClass('rankTitle2');
	    	}else{
	    		$('#rankTitle').removeClass('rankTitle2');
	    	}
    	});
    },
    components:{
	  'v-songlist':songList,
  	},
    methods: {
      back(){
      	this.$router.go(-1);
      	this.$store.commit('setIscurrent', -1);
      	//this.$store.commit('navShow', true);
      },
      /*startView:function(){
      	this.$store.commit('setGuodu',true);
      	var _this=this;
		$.ajax({ 
			type:"get",
			url: "http://www.broadcare.com.cn/kugouAPI/newSongList.php?url="+_this.singerList[0].location,
			success: function(data){
				var div = document.createElement('div');
				div.innerHTML = data;
				var list = div.querySelectorAll('#panelSongsList li');
				var songList = [];
				for(var i=0;i<list.length;i++){
					var song={};
					song.title=list[i].querySelector('.panel-songs-item-name span').textContent;
					song.hash=list[i].id.substr(6);
					songList.push(song);
				}
				//_this.singerImg=div.querySelector('#imgBoxInfo img').getAttribute('src');
				//_this.singerInfo=div.querySelector('#introBox').textContent;
				_this.songList=songList;
				_this.$store.commit('setSongList',songList);
				_this.$store.commit('setGuodu',false);
			},
			error:function(){
				alert(-1)
			}
		});
      },*/
      startView:function(){
      	this.$store.commit('setGuodu',true);
      	var _this=this;
		$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/singerInfo?singerID="+_this.singerList[_this.rankPageIndex].location.split('/')[2],
			success: function(data){
				var div = document.createElement('div');
				div.innerHTML = data;
				
				if (div.querySelector('#imgBoxInfo')) {
		          _this.singerImg = div.querySelector('#imgBoxInfo img').src;
		          //_this.singerName = div.querySelector('.page-title').innerText;
		          _this.singerInfo = div.querySelector('#introBox p').innerText;
		          var songList = [];
		          var list = div.querySelectorAll('.panel-songslist-item');
		          for (let i = 0; i < list.length; i++) {
		            var song = {};
		            song.title = list[i].querySelector('.panel-songs-item-name span').innerText;
		            song.hash = list[i].id.substr(6);
		            songList.push(song)
		          }
		        } else {
		          //var imgSrc_A = div.querySelector('.sng_ins_1 .top img').getAttribute("_src").split('/120');
		          //this.singerImg = imgSrc_A[0] + '/480' + imgSrc_A[1];
		          _this.singerImg = div.querySelector('.sng_ins_1 .top img').getAttribute("_src").replace('/120/','/480/');
		         // _this.singerName = div.querySelector('.sng_ins_1 .top .intro .clear_fix').innerText;
		          _this.singerInfo = div.querySelector('#text .bordr_cen').innerText;
		          var songList = [];
		          var list = div.querySelectorAll('#song_container li');
		          for (let i = 0; i < list.length; i++) {
		            var song = {};
		            var song_info = list[i].querySelector('.song_hid').value.split("|");
		            song.title = song_info[0];
		            song.hash = song_info[1];
		            songList.push(song);
		          }
				_this.songList=songList;
				_this.$store.commit('setSongList',_this.songList);
				_this.$store.commit('setGuodu',false);
		        }
			},
			error:function(){
				alert(-1)
			}
		});
      },
    }
  }
</script>

<style scoped>
.rankHead{height: 35%;}
.songList{top:46%;z-index: 11;}
.plistText{width: 100%; background: rgba(0,0,0,0.5);position: absolute;z-index: 11;color: #fff;bottom:0%;left:0;padding: 10px 20px 10px 20px;box-sizing: border-box;font-size: 12px;}
</style>


// WEBPACK FOOTER //
// singer_info.vue?1fa5908e